



































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import CharacterIcon from '@/components/parts/CharacterIcon.vue';
import * as api from '@/api/api';
import * as def from '@/common/definitions';
import ArrayUtil from '@/models/common/arrayutil';
import Enumerable from 'linq';
import NotificationService from '../../services/notificationservice';

class CharacterItemListItem {
  public get count(): number {
    return this.data.length;
  }

  public constructor(public type: def.CharacterItemType,
                     public data: api.CharacterItem[]) {}
}

@Component({
  components: {
    CharacterIcon,
  },
})
export default class CharacterItemList extends Vue {
  @Prop() public items!: api.CharacterItem[];
  public itemTypes: CharacterItemListItem[] = [];
  public pendingTypes: CharacterItemListItem[] = [];
  public isLoading: boolean = false;
  @Prop({
    default: false,
  }) public canEdit!: boolean;
  @Prop({
    default: false,
  }) public canEditPending!: boolean;
  @Prop({
    default: false,
  }) public isShowPendings!: boolean;
  @Prop({
    default: false,
  }) public isSell!: boolean;
  @Prop({
    default: false,
  }) public isBuy!: boolean;
  @Prop({
    default: false,
  }) public isHandOver!: boolean;
  @Prop({
    default: false,
  }) public isUse!: boolean;
  @Prop({
    default: () => new def.CharacterItemType(-1),
  }) public value!: def.CharacterItemType;
  @Prop({
    default: () => [],
  }) public skills!: api.CharacterSkill[];

  @Watch('items')
  @Watch('isSell')
  @Watch('isHandOver')
  public onTypesChanged() {
    this.itemTypes = this.getItemTypes((i) => i.status !== api.CharacterItem.statusCharacterPending);
    this.pendingTypes = this.getItemTypes((i) => i.status === api.CharacterItem.statusCharacterPending);
  }

  private getItemTypes(subject: (item: api.CharacterItem) => boolean): CharacterItemListItem[] {
    const types = Enumerable.from(this.items)
      .where((i) => subject(i))
      .groupBy((i) => i.type)
      .join(
        def.CHARACTER_ITEM_TYPES,
        (ig) => ig.key(),
        (i) => i.id,
        (ig, it) => new CharacterItemListItem(it, ig.toArray()));

    const items = types.where((i) => !i.type.isResource);
    const resources = types.where((i) => i.type.isResource)
      .groupBy((i) => i.type.id)
      .select((i) =>
        new CharacterItemListItem(i.first().type, [
          new api.CharacterItem(i.first().data[0].id,
                                api.CharacterItem.statusTownOnSale,
                                i.first().type.id, 0, 0, i.sum((j) => Enumerable.from(j.data).sum((k) => k.resource)),
                                i.selectMany((j) => j.data)
                                 .orderBy((k) => api.GameDateTime.toNumber(k.lastStatusChangedGameDate))
                                 .first().lastStatusChangedGameDate,
                                i.first().data[0].isAvailable),
        ]));

    return items
      .concat(resources)
      .where((i) => this.isHandOver ? i.type.canHandOver : true)
      .where((i) => this.isSell ? i.type.canSell : true)
      .where((i) => this.isUse ? i.type.canUse : true)
      .toArray();
  }

  private getItemMoney(item: CharacterItemListItem): number {
    const m = !item.type.isResource ? item.type.money : item.data[0].resource * item.type.money;

    if (this.isSell) {
      return m / 2;
    } else if (this.isBuy) {
      if (this.skills.some((s) => s.type === 15)) {
        return Math.floor(m * 0.8);
      }
    }
    return m;
  }

  private toggleItemAvailable(item: CharacterItemListItem) {
    this.isLoading = true;
    api.Api.addCharacterItem(item.type.id, item.data[0].id, api.CharacterItem.statusCharacterHold,
                             !item.data[0].isAvailable)
      .then(() => {
        // item.data[0].isAvailable = !item.data[0].isAvailable;
      })
      .catch(() => {
        NotificationService.itemAvailableChangeFailed.notify();
      })
      .finally(() => {
        this.isLoading = false;
      });
  }
}
